const PrizeTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<p className="bg-bg rounded-[16px] px-4 py-3 max-sm:w-fit">{children}</p>
);

export default PrizeTag;
